import { Select } from "antd"
import { useEffect, useState } from "react"
import { getUniqueValuesFromArray } from "../../../utils/masterHelper"

const DropdownInput = ({ data, masterData, fieldLabel, handleChange, parentValue, width="50%" }) => {
    const [options, setOptions] = useState([])

    useEffect(() => {
        let uniqueData = [...masterData]
        if(parentValue && data[parentValue]) {
            uniqueData = masterData.filter(obj => obj[parentValue] === data[parentValue])
        } 
        uniqueData = getUniqueValuesFromArray(uniqueData, fieldLabel)
        uniqueData = uniqueData.map(rowData => {
            return { label: rowData[fieldLabel], value: rowData[fieldLabel] }
        })
        setOptions(uniqueData)
    },[])

    return (
        <Select options={options} value={data[fieldLabel]} onChange={(val) => handleChange(data, fieldLabel, val)} style={{ width: width }} />
    )
}

export default DropdownInput